import { T } from "../tokens";

export interface BreathDotProps {
  size?: number;
  color?: string;
  ripple?: boolean;
  /**
   * Day Final: ripple intensity 0..1 — drives ripple duration (faster when
   * stronger), opacity, and breath speed. Used by MapView to express
   * "getting closer to the hidden item" without changing the UI to numbers.
   * 0 = barely breathing, 1 = urgent pulse.
   */
  intensity?: number;
}

export function BreathDot({
  size = 8,
  color = T.ink700,
  ripple = false,
  intensity = 0.5,
}: BreathDotProps) {
  const clamped = Math.max(0, Math.min(1, intensity));
  // Ripple duration: 5s at idle, 1.5s at full intensity
  const rippleDur = `${(5 - clamped * 3.5).toFixed(2)}s`;
  // Breath duration: 3.5s at idle, 1.2s at full
  const breathDur = `${(3.5 - clamped * 2.3).toFixed(2)}s`;
  // Ripple stroke opacity scales with intensity
  const rippleStroke = `rgba(14,14,14,${(0.12 + clamped * 0.28).toFixed(2)})`;
  // More ripple layers when intense (1 → 3)
  const rippleCount = ripple ? 1 + Math.round(clamped * 2) : 0;

  return (
    <div style={{ position: "relative", width: size, height: size }}>
      {Array.from({ length: rippleCount }).map((_, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            inset: 0,
            border: `1px solid ${rippleStroke}`,
            borderRadius: "50%",
            animation: `ruifang-ripple ${rippleDur} var(--ease-mist) infinite`,
            animationDelay: `${-i * (parseFloat(rippleDur) / Math.max(rippleCount, 1))}s`,
          }}
        />
      ))}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: color,
          borderRadius: "50%",
          animation: `ruifang-breath ${breathDur} var(--ease-mist) infinite`,
        }}
      />
    </div>
  );
}
